import { useState, useEffect } from 'react';

const STORAGE_KEY = 'teamnl_authenticated';
const PASSWORD = 'teamnl';

export const usePasswordAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const authenticated = localStorage.getItem(STORAGE_KEY) === 'true';
      setIsAuthenticated(authenticated);
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  const authenticate = (password) => {
    if (password === PASSWORD) {
      localStorage.setItem(STORAGE_KEY, 'true');
      setIsAuthenticated(true);
      return true;
    }
    return false;
  };

  return {
    isAuthenticated,
    isLoading,
    authenticate
  };
};